<template>
  <dpc-form v-model:fields="fields" :before-submit-hook="beforeSubmitHook">
    <slot />
  </dpc-form>
</template>

<script setup>
import { inject, watch, computed, reactive, ref, toRefs } from 'vue';
import useUrlParams from '@composables/use-url-params';
import pick from 'lodash/pick';

const emit = defineEmits(['submit']);

const props = defineProps({
  useHistory: {
    type: Array,
    default: () => [],
  },
  manualSubmit: {
    type: Boolean,
    default: false,
  },
  beforeSubmitHook: {
    type: Function,
    default() {
      return () => true;
    },
  },
});

const { useHistory, manualSubmit } = toRefs(props);

const fields = ref({});
const setOverwriteParam = inject('api/setOverwriteParam');
const clearResponseHistory = inject('api/clearResponseHistory');

if (useHistory.value) {
  const historyFields = computed(() => pick(fields.value, useHistory.value));
  const { params: urlSearchParams } = useUrlParams();
  useHistory.value.forEach(key => {
    const value = urlSearchParams[key];
    if (!value) return;
    fields.value[key] = JSON.parse(decodeURIComponent(value));
  });

  watch(
    historyFields,
    historyFields => {
      Object.entries(historyFields).forEach(([key, value]) => {
        if (!value) return;
        urlSearchParams[key] = encodeURIComponent(JSON.stringify(value));
      });
    },
    { deep: true, immediate: true }
  );
}

const updateEndpoint = () => {
  if (!props.beforeSubmitHook(fields.value)) return;
  clearResponseHistory();
  setOverwriteParam('query', JSON.parse(JSON.stringify(fields.value)));
  emit('submit', JSON.parse(JSON.stringify(fields.value)));
};

watch(
  fields,
  fields => {
    if (manualSubmit.value) return false;
    updateEndpoint();
  },
  { deep: true }
);

const beforeSubmitHook = () => {
  if (!manualSubmit.value) return false;
  updateEndpoint();
  return false;
};
</script>
